import polyfill from "./internal/polyfills/Number.isFinite";

const isFinite = Number.isFinite || polyfill;

export default isFinite;
